(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(max-width: 1099px)');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    // Un seul timer global : fonctionne aussi après un rechargement de section dans l'éditeur
    setInterval(function () {
      if (!mq.matches || reduced.matches) return;
      document.querySelectorAll('[data-rd-announce]').forEach(function (root) {
        var items = root.querySelectorAll('[data-rd-announce-item]');
        if (items.length < 2) return;
        var current = 0;
        items.forEach(function (el, i) { if (el.classList.contains('is-active')) current = i; });
        items[current].classList.remove('is-active');
        items[(current + 1) % items.length].classList.add('is-active');
      });
    }, 4500);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-compare"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Recopie la valeur du curseur dans la variable CSS --rd-pos : le masque et la poignée suivent
    document.addEventListener('input', function (e) {
      var range = e.target;
      if (!range.classList || !range.classList.contains('rd-cmp__range')) return;
      var root = range.closest('.rd-cmp');
      if (root) root.style.setProperty('--rd-pos', range.value);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-trust-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(max-width: 749px)');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    function currentIndex(track) {
      var w = track.clientWidth;
      return w ? Math.round(track.scrollLeft / w) : 0;
    }

    function syncDots(root) {
      var track = root.querySelector('[data-rd-trust-track]');
      var dots = root.querySelectorAll('[data-rd-trust-dot]');
      if (!track || !dots.length) return;
      var i = currentIndex(track);
      dots.forEach(function (dot, n) {
        if (n === i) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    function goTo(root, index) {
      var track = root.querySelector('[data-rd-trust-track]');
      if (!track) return;
      track.scrollTo({ left: index * track.clientWidth, behavior: reduced.matches ? 'auto' : 'smooth' });
    }

    // Mise à jour des points pendant le glissement (le scroll ne remonte pas : capture)
    var ticking = false;
    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('[data-rd-trust-track]') || ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        syncDots(t.closest('[data-rd-trust]'));
      });
    }, true);

    // Clic sur un point
    document.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-rd-trust-dot]');
      if (!dot) return;
      var root = dot.closest('[data-rd-trust]');
      root.dataset.rdStopped = '1';
      goTo(root, parseInt(dot.getAttribute('data-rd-trust-dot'), 10));
    });

    // Dès que la personne touche le carrousel, le défilement auto s'arrête définitivement
    ['pointerdown', 'focusin'].forEach(function (name) {
      document.addEventListener(name, function (e) {
        var root = e.target.closest && e.target.closest('[data-rd-trust]');
        if (root) root.dataset.rdStopped = '1';
      });
    });

    // Défilement automatique (mobile uniquement, désactivé si "réduire les animations")
    setInterval(function () {
      if (!mq.matches || reduced.matches) return;
      document.querySelectorAll('[data-rd-trust][data-autoplay="true"]').forEach(function (root) {
        if (root.dataset.rdStopped === '1') return;
        var delay = parseInt(root.getAttribute('data-delay'), 10) || 4;
        var elapsed = (parseInt(root.dataset.rdElapsed, 10) || 0) + 1;
        if (elapsed < delay) { root.dataset.rdElapsed = elapsed; return; }
        root.dataset.rdElapsed = 0;
        var track = root.querySelector('[data-rd-trust-track]');
        var total = track.children.length;
        goTo(root, (currentIndex(track) + 1) % total);
      });
    }, 1000);
  })();

  } catch(e) { console.error(e); }
})();
})();
